import {Component} from 'react'

import AsyncTypeahead from './AsyncTypeahead.jsx'

import api from '../../../../api.js'

export default class SecteurTypeahead extends Component {
  search = async (query) => {
    return (await api.secteurs.suggest({ search: query })).data
  }

  static defaultProps = {
    ...AsyncTypeahead.defaultProps,
    promptText: 'Entrez le nom de vos secteurs'
  }

  render() {
    const { labelKey, valueField, type, ...rest } = this.props

    return (
      <AsyncTypeahead
        selected={(this.props.input.value ? this.props.input.value : [])}
        onSearch={this.search}
        multiple
        labelKey="name"
        {...rest} />
    )
  }
}
